import {
  BRIGHTCOVE_REG_EXP,
  MICROSOFT_STREAM_REG_EXP,
  SHARE_POINT_REG_EXP,
} from 'core-components/library/richTextEditor/constants'
import { getYoutubeUrl } from 'core-components/library/richTextEditor/helpers/getYoutubeUrl'
import { VIDEO_TYPES } from 'core-components/library/richTextEditor/interface/custom-types'

const videoCorrespondenceData = [
  { regExp: SHARE_POINT_REG_EXP, videoType: VIDEO_TYPES.sharepoint },
  { regExp: MICROSOFT_STREAM_REG_EXP, videoType: VIDEO_TYPES.microsoftstream },
  { regExp: BRIGHTCOVE_REG_EXP, videoType: VIDEO_TYPES.brightcove },
]

export const getVideoInfo = ({ url, startTime }: { url: string; startTime?: number }) => {
  const youtubeUrl = getYoutubeUrl({ url, startTime })
  if (youtubeUrl) {
    return {
      videoType: VIDEO_TYPES.youtube,
      videoUrl: youtubeUrl,
    }
  }
  const videoInfo = videoCorrespondenceData.find((el) => el.regExp.test(url))
  if (videoInfo) {
    return {
      videoType: videoInfo.videoType,
      videoUrl: url,
    }
  }

  return { videoType: VIDEO_TYPES.default, videoUrl: url }
}
